<template>
<div>
  <div  class="tag-container">
    <div class="tag-text">
      <p class="p2">Select at least three</p>
    </div>
    <tag-text-field  v-model="skills" placeholder="Type here or click tags"/>
  </div>
  <div>
    <suggested-tags v-if="Object.keys(this.jobTags).length > 0" @addTag="addSuggestedTag" @removeTag="removeSuggestedTag" :options="jobTags" :value="this.editSkills" ></suggested-tags>
  </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TagTextField from '@/components/general/tag-text-field'
import SuggestedTags from '../../jobs/suggested-tags.vue'

export default {
  components: { TagTextField, SuggestedTags },
  computed: {
    ...mapState('skills', [
      'editSkills'
    ]),
    ...mapState('jobs', ['jobTags']),
    skills: {
      get () { return this.editSkills },
      set (value) { this.setEditSkills(value) }
    }
  },
  methods: {
    ...mapMutations('skills', [
      'setEditSkills'
    ]),
    addSuggestedTag (value) {
      this.setEditSkills([...this.editSkills, value])
    },
    removeSuggestedTag (value) {
      const filteredTags = this.editSkills.filter(tag => tag !== value)
      this.setEditSkills(filteredTags)
    }
  }
}
</script>

<style scoped>
.tag-container{
  margin-bottom: 30px;
}

.tag-text{
  display: flex;
}
.p1{
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;

  color: #080808;
  margin-right: 5px ;
}

.p2{
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;

  color: #979797;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/skills/edit-skills.vue